import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceType } from 'src/app/core/models/service-type';
import { PaginatedResults } from 'src/app/core/models/paginated_results_model';
import { PaginationOptions } from 'src/app/core/models/pagination_options';
import { ServiceTypeService } from 'src/app/core/services/general/service-type.service';

@Component({
  selector: 'app-search-service-type',
  templateUrl: './search-service-type.component.html',
  styleUrls: ['./search-service-type.component.scss']
})
export class SearchServiceTypeComponent {
  public loading = true;
  public initialLoading = true;
  public serviceTypesList!: Array<ServiceType>;
  public paginatedResults!: PaginatedResults;
  public paginationOptions = new PaginationOptions(
    { sort: 'service_type_code', direction: 'asc' },
    'service_types'
  );

  public sortColumns = [
    'service_type_code',
    'description',
    'status',
  ];

  constructor(
    private router: Router,
    private serviceTypeService: ServiceTypeService,
    public activeModal: NgbActiveModal
  ) { }

  ngAfterViewInit(): void {
    this.search();
  }

  search() {
    this.loading = true;
    this.serviceTypeService
      .search(this.paginationOptions)
      .subscribe((res: PaginatedResults) => {
        this.paginatedResults = res;
        this.serviceTypesList = res.data.map((u) => new ServiceType(u));
        this.initialLoading = false;
        this.loading = false;
      });
  }

  select(serviceType: ServiceType) {
    this.activeModal.close(serviceType);
  }

  toggleFilter() {
    this.paginationOptions.toggleFilter();
    this.paginatedResults.current_page = 1;
    this.onPageNumberChanged();
  }

  onPageNumberChanged() {
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.paginationOptions.saveUpdatedOptions();
    this.onPaginationChanged();
  }

  onPerPageChanged() {
    this.paginatedResults.current_page = 1;
    this.paginationOptions.perPage = this.paginatedResults.per_page;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  changeSort(field: any) {
    if (this.paginationOptions.sort === field) {
      this.paginationOptions.toggleDirection();
    } else {
      this.paginationOptions.sort = field;
      this.paginationOptions.resetDirection();
    }

    this.paginatedResults.current_page = 1;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  onPaginationChanged() {
    this.search();
  }
}
